/**
 * Applied to CUI {@link CenteredOverlay} panel via `panelClassName`.
 * Fills available viewport height.
 */
export const settingsModalDesktopPanelCss = "sv5thcl";

/**
 * Inner layout inside {@link CenteredOverlay} body: fills the fixed panel so shell scroll + footer work.
 */
export const settingsModalDesktopPanelInnerCss = "s1sgij0i";

/** Desktop shell: grid keeps nav + main pane bounded; minmax(0,1fr) prevents horizontal blowout. */
export const desktopShellCss = "dqcurt0";

/**
 * Desktop settings sidebar: 208px grey rail; overrides CUI VerticalNav shell (256px / default surface).
 * See Figma: Settings — Admin center (NEW).
 */
export const desktopNavCss = "dvlffji";

/**
 * Pass-through so scroll + footer are direct grid items of `desktopShellCss`
 * (see layout_context SettingsModalContentColumn desktop variant).
 */
export const desktopContentColumnCss = "d2zt533";

/** Grid slot for CUI {@link @calendly/ui/components/page-header} PageHeader (layout + scroll live in CUI). */
export const desktopPageHeaderCss = "d1cx0v2x";
export const desktopBodyScrollCss = "dhvgo26";
export const desktopFooterHostCss = "d1y3s57l";

/** Desktop footer host when no portaled actions are shown — keeps grid row mounted without chrome. */
export const settingsModalDesktopFooterHostHiddenCss = "s10upur3";

/** Portal this inside the footer host; keeps Form actions outside the scroll area. */
export const settingsModalFooterActionsCss = "s573t5j";
export const mobileFullScreenCss = "m1k3f2lt";
export const mobileHeaderCss = "mcok8k9";

/** Mobile settings list: full width; grey rail tone aligned with desktop sidebar. */
export const mobileListCss = "mjyocj9";
export const mobileDetailCss = "mvgumxq";

/** Sticky tab row + title below the mobile shell chrome; keeps tabs visible on phone. */
export const mobilePageHeaderCss = "m1ynmr9t";
export const mobileDetailScrollCss = "m14p5fel";
export const mobileFooterHostCss = "m13wuizx";
export const mobileHeaderCloseButtonCss = "mc0xbpn";

/** Slides the desktop settings modal left when an elevated side rail fits beside it. */
export const settingsModalDesktopRailOffsetPanelCss = "s3kuvy2";

require("./styles.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");